// import { CloseOutlined } from '@ant-design/icons';
import React, {
	FC,
	//  useState
} from 'react';

import { ProductType } from '@/components/Billing/billing-types';
import {
	AppTable,
	TableProps,
	// AppTag, AppPopover
} from '@/react_app/components/Atoms';

const TASKS_USAGE_TITLE = 'Tasks usage';
const TASKS_QUOTA_TITLE = 'Tasks quota';

export interface UsageHistoryTableProps {
	data: DataType[];
	productType: ProductType;
}

interface DataType {
	key: string;
	// dateRange: [number, number];
	date: string;
	event: string;
	plan: string;
	quota: string;
	usage: string;
}

// function formatDate(milliseconds: number) {
// 	const date = new Date(milliseconds);
// 	const options: Intl.DateTimeFormatOptions = {
// 		month: 'short',
// 		day: 'numeric',
// 	};
// 	const formattedDate = date.toLocaleDateString('en-US', options);
// 	const year = date.getFullYear();
// 	return `${formattedDate}, ${year}`;
// }

// function formatNumber(number: number) {
// 	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
// }

// const UsageCell = ({ usage }: { usage: number }) => {
// 	const [open, setOpen] = useState(false);

// 	const hide = () => {
// 		setOpen(false);
// 	};

// 	const handleOpenChange = (newOpen: boolean) => {
// 		setOpen(newOpen);
// 	};
// 	return (
// 		<div className="text-colorText">
// 			<div className="text-colorText">{formatNumber(usage)}</div>
// 			<AppPopover
// 				content={
// 					<div>
// 						<div>Billing cycle: Mar 25, 2025 - Apr 24, 2025</div>
// 						<div className="uppercase mt-8 text-colorTextSecondary text-xs font-medium flex items-center justify-between pb-4 w-full border-b border-[#D9D9D9]">
// 							<div>Action</div>
// 							<div>Credits consumed</div>
// 						</div>
// 						<div className="py-2.5 text-[13px] flex items-center justify-between">
// 							<div>AI text parser</div>
// 							<div>{formatNumber(2846)}</div>
// 						</div>
// 						<div className="py-2.5 text-[13px] flex items-center justify-between">
// 							<div>OCR document parser</div>
// 							<div>{formatNumber(280)}</div>
// 						</div>
// 						<div className="py-2.5 text-[13px] flex items-center justify-between">
// 							<div>Summarize a text</div>
// 							<div>{formatNumber(93)}</div>
// 						</div>
// 						<div className="flex justify-between text-sm font-medium text-colorText pt-4 border-t border-[#D9D9D9]">
// 							<div>Total</div>
// 							<div>{formatNumber(3219)}</div>
// 						</div>
// 					</div>
// 				}
// 				overlayStyle={{
// 					width: 540,
// 				}}
// 				title={
// 					<div className="flex justify-between w-full center gap-7">
// 						<div>Ply credit consumption action breakdown</div>
// 						<button onClick={hide}>
// 							<CloseOutlined />
// 						</button>
// 					</div>
// 				}
// 				placement="right"
// 				trigger="click"
// 				open={open}
// 				onOpenChange={handleOpenChange}
// 			>
// 				<button className="underline hover:no-underline">See breakdown</button>
// 			</AppPopover>
// 		</div>
// 	);
// };

const columns: TableProps<DataType>['columns'] = [
	// {
	// 	title: 'Quota cycle',
	// 	dataIndex: 'dateRange',
	// 	key: 'dateRange',

	// 	render: (_, { dateRange }, index) => (
	// 		<div className="flex items-center">
	// 			<span className="text-colorText">
	// 				{index === 0 && (
	// 					<div className="block mb-1">
	// 						<AppTag color="purple">Current billing cycle</AppTag>
	// 					</div>
	// 				)}
	// 				{formatDate(dateRange[0])} - {formatDate(dateRange[0])}
	// 			</span>
	// 		</div>
	// 	),
	// },
	{
		title: 'Date',
		dataIndex: 'date',
		key: 'date',

		render: (date) => <div className="text-colorTextSecondary">{date}</div>,
	},
	{
		title: 'Event',
		dataIndex: 'event',
		key: 'event',

		render: (event) => <div className="text-colorTextSecondary">{event}</div>,
	},
	{
		title: 'Plan',
		dataIndex: 'plan',
		key: 'plan',
		render: (plan) => <div className="text-colorTextSecondary">{plan}</div>,
	},
	{
		title: TASKS_USAGE_TITLE,
		dataIndex: 'usage',
		key: 'usage',
		render: (usage) => <div className="text-colorTextSecondary">{usage}</div>,
	},
	{
		title: TASKS_QUOTA_TITLE,
		dataIndex: 'quota',
		key: 'quota',
		render: (quota) => <div className="text-colorTextSecondary">{quota}</div>,
	},
];

const teamColumns: TableProps<DataType>['columns'] = [
	...columns,
	{
		title: 'Members',
		dataIndex: 'usersUsage',
		key: 'usersUsage',
		render: (usersUsage) => <div className="text-colorTextSecondary">{usersUsage}</div>,
	},
	{
		title: 'Members quota',
		dataIndex: 'usersQuota',
		key: 'usersQuota',
		render: (usersQuota) => <div className="text-colorTextSecondary">{usersQuota}</div>,
	},
];
const creditsColumns: TableProps<DataType>['columns'] = columns.map((c) => ({
	...c,
	title: c.title === TASKS_USAGE_TITLE ? 'Credits usage' : c.title === TASKS_QUOTA_TITLE ? 'Credits quota' : c.title,
}));

const getColumns = (productType: ProductType) => {
	switch (productType) {
		case ProductType.TeamFeatures:
			return teamColumns;
		case ProductType.Credits:
			return creditsColumns;
		default:
			return columns;
	}
};
const UsageHistoryTable: FC<UsageHistoryTableProps> = ({ data, productType }) => (
	<AppTable columns={getColumns(productType)} dataSource={data} pagination={false} />
);

export default UsageHistoryTable;
